import React from "react"
import { ApolloError } from "apollo-client"

type LoadingWrapperProps = {
  loading: boolean
  error: ApolloError | ApolloError[] | undefined
}

export const LoadingWrapper: React.FC<LoadingWrapperProps> = ({ loading, error, children }) => {
  if (loading || error || navigator?.userAgent === "ReactSnap") {
    return null
  }

  return <>{children}</>
}
